<template>
  <div v-if="enableWebSite" class="site">
    <a href="#contenido-principal" class="site-skip">Saltar al contenido</a>

    <Navbar class="cabecera" />

    <div id="contenido-principal" class="site-main">
      <keep-alive :exclude="['vistaCarrete', 'vistaNoticia', 'HomePage']">
        <router-view class="body" />
      </keep-alive>
    </div>

    <footer-site />

    <template v-if="popUpList.length">
      <popup v-for="popUp in popUpList" :key="popUp.id" :popUp="popUp" :id="popUp.id" />
    </template>

    <BackToTop />
    <aviso-cookies />
  </div>
  <mantenimiento-view v-else />
</template>

<script>
import footerSite from "@/components/footer.vue";
import axios from "@/directives/axios.js";
import popup from "@/components/popUp.vue";
import mantenimientoView from "./Mantenimiento.vue";

import Navbar from "@/components/layout/AppNavbar.vue";
import BackToTop from "@/components/layout/BackToTop.vue";
import AvisoCookies from "@/components/layout/AvisoCookies.vue";

export default {
  name: "homeWebSite",
  components: {
    mantenimientoView,
    footerSite,
    popup,
    BackToTop,
    AvisoCookies,
    Navbar,
  },
  data() {
    return {
      popUpList: [],
      enableWebSite: this.$root.constantes.enableWebSite,
    };
  },
  metaInfo() {
    return {
      title: this.$root.constantes.nombre_sitio,
      meta: [
        {
          name: "description",
          content: `Informacion sobre la ${this.$root.constantes.nombre_sitio}.`,
        },
        {
          name: "keywords",
          content: `${this.$root.constantes.nombre_sitio}, ${this.$root.constantes.nombre_sitio}, misas ${this.$root.constantes.nombre_ciudad}, ${this.$root.constantes.nombre_sitio}, misas ${this.$root.constantes.nombre_sitio}`,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://santodomingocartagena.com",
        },
      ],
    };
  },
  methods: {
    hoyISO() {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    },
    async getPopUps() {
      try {
        const { data } = await axios.get(`/popup/popUpDia?fecha=${this.hoyISO()}`);
        this.popUpList = data.listaPopUp || [];
      } catch (e) {
        this.popUpList = [];
      }
    },
  },
  mounted() {
    // Cookie de mantenimiento: permite ver la web aunque esté desactivada
    if (this.$cookies.get("mantenimiento")) {
      this.enableWebSite = true;
    }
    this.$emit("datosCargados", false);
    this.getPopUps();
  },
};
</script>

<style scoped>
.site {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--sd-bg);
}

.site-main {
  flex: 1;
}

.site-skip {
  position: fixed;
  top: -60px;
  left: 16px;
  z-index: 2000;
  padding: 10px 16px;
  border-radius: 10px;
  background: var(--sd-primary);
  color: var(--sd-primary-contrast);
  font-weight: 600;
  text-decoration: none;
  transition: top 0.15s;
}

.site-skip:focus {
  top: 16px;
  color: var(--sd-primary-contrast);
}
</style>
